<h3 class="mobi-ui-font-tisa">{{ coverSheet().title }}</h3>
<p class="mobi-ui-font-size-50 xs:mobi-ui-font-size-100">
    {{ coverSheet().content }}
    <br />
    {{ coverSheet().info }}
</p>
